<template>
    <div id="food-page">
        <div v-if="currentFoodTopAd" v-on:click="handleAdClick(currentFoodTopAd)" class="header-banner" style="margin-bottom: 20px;">
            <img :src="currentFoodTopAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentFoodTopAd" v-on:click="handleAdClick(currentFoodTopAd)" class="header-banner-mobile"  style="margin-bottom: 20px;">
            <img :src="currentFoodTopAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
        <div class="food-page">
            <div class="food-categories-wrap">
                <p>Hvað er í matinn?</p>
                <div class="food-category-wrap">

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'nautakjot'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-red"><img src="../assets/icons/food/nautakjot.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Nautakjöt
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'lambakjot'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-red"><img src="../assets/icons/food/lambakjot.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Lambakjöt
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'svinakjot'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-red"><img src="../assets/icons/food/svinakjot.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Svínakjöt
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'alifuglar'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-creme"><img src="../assets/icons/food/alifugl.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Alifuglar
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'fiskur'} }">
                        <div class="food-category">
                            <div class="food-category-icon-wrap">
                                <div class="food-category-icon icon-blue"><img src="../assets/icons/food/fiskur.png" alt=""></div>
                            </div>
                            <div class="food-category-title-wrap">
                                <div class="food-category-title">
                                    Fiskur
                                </div>
                            </div>
                        </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'skelfiskur'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-blue"><img src="../assets/icons/food/skelfiskur.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Skelfiskur
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'saltfiskur'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-blue"><img src="../assets/icons/food/saltfiskur.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Saltfiskur
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'graenmetisrettir'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-green"><img src="../assets/icons/food/graenmetisrettir.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Grænmetisréttir
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'villibrad'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-brown"><img src="../assets/icons/food/villibrad.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Villibráð
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'lettari-villibrad'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-brown"><img src="../assets/icons/food/lettari-villibrad.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Léttari villibráð
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'pylsur'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-brown"><img src="../assets/icons/food/pylsur.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Pylsur
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'reykt-kjot'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-pink"><img src="../assets/icons/food/reykt-kjot.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Reykt Kjöt
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'austurlenskt'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-seablue"><img src="../assets/icons/food/austurlenskt.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Austurlenskt
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'ostar'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-yellow"><img src="../assets/icons/food/ostar.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Ostar
                            </div>
                        </div>
                    </div>
                    </router-link>
                    
                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'pasta'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-yellow"><img src="../assets/icons/food/pasta.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Pasta
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'sterkkryddad'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-yellow"><img src="../assets/icons/food/sterkkryddad.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Sterkkryddað
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'pizza'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-yellow"><img src="../assets/icons/food/pizza.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Pizza
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'smarettir'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-orange"><img src="../assets/icons/food/smarettir.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Smáréttir
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'sushi'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-orange"><img src="../assets/icons/food/sushi.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Sushi
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'eftirrettir'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-purple"><img src="../assets/icons/food/eftirrettir.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Eftirréttir
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'pottrettir'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-darkbrown"><img src="../assets/icons/food/pottrettir.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Pottréttir
                            </div>
                        </div>
                    </div>
                    </router-link>
                </div>
            </div>
            <div class="food-categories-wrap">
                <p>Annað</p>
                <div class="food-category-wrap">
                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'grill'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-dark"><img src="../assets/icons/food/grill.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Grill
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'ma-geyma'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-dark"><img src="../assets/icons/food/ma-geyma.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Má Geyma
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'umhella'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-dark"><img src="../assets/icons/food/umhella.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Umhella
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'vegan'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-green"><img src="../assets/icons/food/vegan.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Vegan
                            </div>
                        </div>
                    </div>
                    </router-link>
                    
                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'lifraent'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-green"><img src="../assets/icons/food/lifraent.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Lífrænt
                            </div>
                        </div>
                    </div>
                    </router-link>
                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'natturuvin'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-green"><img src="../assets/icons/food/natturuvin.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Náttúruvín
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'an-matar'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-purple"><img src="../assets/icons/food/an-matar.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Án matar
                            </div>
                        </div>
                    </div>
                    </router-link>

                    <router-link :to="{ name: 'catalog-page', params: {refCategory: 'fordrykkur'} }">
                    <div class="food-category">
                        <div class="food-category-icon-wrap">
                            <div class="food-category-icon icon-purple"><img src="../assets/icons/food/fordrykkur.png" alt=""></div>
                        </div>
                        <div class="food-category-title-wrap">
                            <div class="food-category-title">
                                Fordrykkur
                            </div>
                        </div>
                    </div>
                    </router-link>
                    
                </div>
            </div>
        </div>
        <div v-if="currentFoodBottomAd" v-on:click="handleAdClick(currentFoodBottomAd)" class="footer-banner">
            <img :src="currentFoodBottomAd.imageBanner | optimizeBanner" alt="">
        </div>
        <div v-if="currentFoodBottomAd" v-on:click="handleAdClick(currentFoodBottomAd)" class="footer-banner-mobile">
            <img :src="currentFoodBottomAd.imageBannerMobile | optimizeBanner" alt="">
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')

export default {
    data() {
        return {
            
        }
    },
    computed: {
        ...mapState(["categories", 'currentFoodTopAd', 'currentFoodBottomAd'])
    },
    filters: {
        optimizeBanner: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto/')
            return newUrl
        }
    },
    methods: {
        handleAdClick(ad) {
            window.open(ad.url)
            fb.db.collection("ads").doc(ad.id).update({
                clicks: ad.clicks + 1,
            })
        }
    }
}
</script>

<style>
@media only screen and (max-width: 768px) {
    .food-category-wrap {
        width:100%;
    }
}
@media only screen and (min-width: 769px) {

}
@media only screen and (min-width: 1200px) {
    .food-category-wrap {
        width:690px;
    }
}
.food-page {
    margin-top: 20px;
    background-color: white;
}
.food-page p {
    font-size: 32px;
}
.food-categories-wrap {
    width:100%;
    background-color: white;
    padding-top: 20px;
}
.food-categories-wrap p {
    color: #b33b3b;
    margin-top: 0px;
}
.food-category-wrap {
    margin: auto;
    display:flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.food-category {
    width:100px;
    height:100px;
    margin:auto;
    cursor: pointer;
}
.food-category-icon {
    margin:auto;
    height:50px;
    width:50px;
    /*background-color: #b33b3b;*/
    /*border-radius: 50%;*/
    border-radius: 5px;
}
.icon-blue {
    background-color: #08B2E3;
}
.icon-red {
    background-color: #D72638;
}
.icon-brown {
    background-color: #A86B01;
}
.icon-green {
    background-color: #7FB800;
}
.icon-yellow {
    background-color: #F0C808;
}
.icon-purple {
    background-color: #8D4BCC;
}
.icon-creme {
    background-color: #C4AF9A;
}
.icon-darkbrown {
    background-color: #5E3023;
}
.icon-pink {
    background-color: #F7A9A8;
}
.icon-dark {
    background-color: #2c3e50;
}
.icon-orange {
    background-color: #F17F29;
}
.icon-seablue {
    background-color: #048A81;
}
.food-category-icon img {
    height: 30px;
    margin-top: 10px;
    filter: brightness(0) invert(1);
}
.food-category-title {
    text-align: center;
    font-size: 16px;
}
.food-category:hover .food-category-icon {
    opacity: 0.9;
    height:54px;
    width: 54px;
    margin-top: -2px;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
}
.food-category:hover .food-category-icon img {
    height:32px
}
.food-category:hover .food-category-title {
    margin-top: -2px;
}
</style>